import { createSlice } from "@reduxjs/toolkit";
import { getMainStoriesList, getMyStoriesList, getPrivateStoriesList } from "./thunk";

const getStoriesData = (oldData = {}, newData = {}, page = 1) => {
  const data =
    page == 1
      ? newData || {}
      : {
          ...(newData || {}),
          records: [...(oldData?.records || []), ...(newData?.records || [])],
        };

  return data;
};

const initialState = {
  loadingStoriesList: false,
  loadingPrivateStories: false,
  loadingMyStories: false,
  storiesList: {},
  privateStoriesList: {},
  myStoriesList: {},
};

const slice = createSlice({
  name: "stories",
  initialState: { ...initialState },
  reducers: {
    updateStoriesList: (state, action) => {
      const { listFor } = action.payload || {};

      if (listFor === "private") {
        state.privateStoriesList = action.payload;
      } else if (listFor === "myStories") {
        state.myStoriesList = action.payload;
      } else {
        state.storiesList = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPrivateStoriesList.pending, (state, action) => {
        state.loadingPrivateStories = true;
      })
      .addCase(getPrivateStoriesList.fulfilled, (state, action) => {
        state.loadingPrivateStories = false;
        state.privateStoriesList = action.payload?.data || {};
      })
      .addCase(getPrivateStoriesList.rejected, (state, action) => {
        state.loadingPrivateStories = false;
      });
    builder
      .addCase(getMyStoriesList.pending, (state, action) => {
        state.loadingMyStories = true;
      })
      .addCase(getMyStoriesList.fulfilled, (state, action) => {
        state.loadingMyStories = false;
        state.myStoriesList = action.payload?.data || {};
      })
      .addCase(getMyStoriesList.rejected, (state, action) => {
        state.loadingMyStories = false;
      });
    builder
      .addCase(getMainStoriesList.pending, (state, action) => {
        state.loadingStoriesList = true;
      })
      .addCase(getMainStoriesList.fulfilled, (state, action) => {
        state.loadingStoriesList = false;
        const { page, data = {} } = action.payload || {};

        state.storiesList = getStoriesData(state.storiesList, data || {}, page);
      })
      .addCase(getMainStoriesList.rejected, (state, action) => {
        state.loadingStoriesList = false;
      });
  },
});

export default slice.reducer;
export const { updateStoriesList } = slice.actions;
